import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CropperComponent } from "app/cropper/cropper.component";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";
import { ImageTransform } from "ngx-image-cropper";
import { Observable, Observer } from "rxjs";

@Component({
  selector: "app-edit-service-sub-cat",
  templateUrl: "./edit-service-sub-cat.component.html",
  styles: [],
})
export class EditServiceSubCatComponent implements OnInit {
  @Input() content: any;
  subName = "";
  subDescription = "";
  subCategories = [];
  editIndex = 0;
  action = "";
  action2 = "";
  subCategoryArray = [];
  subCatimageloader = false;
  subCatmediaLoader = false;
  subCatmediaMessage = "";
  subCatuploadMediaSuccess = "";
  subcatImgUrl = "";

  files = [];
  transform: ImageTransform = {};
  base64TrimmedURL = "";
  fileAcceptedTypes = ["jpeg", "png", "gif", "pdf", "docx"];

  apiUrl =
    JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(
    public dialogRef: NgbActiveModal,
    public service: PageService,
    public http: HttpClient,
    public modalService: NgbModal
  ) {}

  ngOnInit(): void {
    console.log(this.content);
    console.log(this.content.editIndex);
    this.subCategories = this.content.subCategories;
    this.editIndex = this.content.editIndex;
    this.action = this.content.action;
    this.action2 = this.content.action2;
    if (!this.action2) {
      this.subName = this.subCategories[this.editIndex]["name"];
      this.subDescription = this.subCategories[this.editIndex]["description"];
      this.subcatImgUrl = this.subCategories[this.editIndex]["media"];
      this.subCategoryArray = this.content.subCategoryArray;
    }
  }

  updateSubCategory(name, description, image) {
    this.subCategories[this.editIndex]["name"] = this.subName;
    this.subCategories[this.editIndex]["description"] = this.subDescription;
    this.subCategories[this.editIndex]["media"] = this.subcatImgUrl;
    this.dialogRef.close({ success: true });
  }
  deleteSubCategory(index) {
    this.subCategories = this.subCategories.splice(index, 1);
    this.dialogRef.close({ success: true });
  }

  permanentDeleteSubCategory(index) {
    this.dialogRef.close({ success: true });
    this.service
      .deleteSevicesSubCategory(this.subCategories[index]["_id"])
      .then((response) => {})
      .catch((error) => {});
    this.subCategories = this.subCategories.splice(index, 1);
    this.dialogRef.close({ success: true });
  }

  /* Method to convert Base64Data Url as Image Blob */
  dataURItoBlob(dataURI: string): Observable<Blob> {
    return Observable.create((observer: Observer<Blob>) => {
      const byteString: string = window.atob(dataURI);
      const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: "image/jpeg" });
      observer.next(blob);
      observer.complete();
    });
  }

  /**Method to Generate a Name for the Image */
  generateName(): string {
    const date: number = new Date().valueOf();
    let text: string = "";
    const possibleText: string =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 5; i++) {
      text += possibleText.charAt(
        Math.floor(Math.random() * possibleText.length)
      );
    }
    // Replace extension according to your media type like this
    return date + "." + text + ".jpeg";
  }

  uploadSubCatImag(event) {
    this.subCatimageloader = true;
    this.subCatmediaMessage = "";
    this.subCatuploadMediaSuccess = "";
    this.files = event.target.files;
    const files = this.files;
    const fileType = files[0].type.split("/")[1];
    if (this.fileAcceptedTypes.indexOf(fileType) === -1) {
      this.subCatmediaMessage = "Please Upload File (.jpeg,.jpg,.png)";
      return;
    }
    var formData = new FormData();
    console.log(formData);
    Array.from(files).forEach((f) => {
      var fileSize = f.size;
      var i = 0;
      if (fileSize / (1024 * 1024) >= 5) {
        this.subCatimageloader = false;
        this.subCatmediaMessage = "Please upload an image less than 5mb";
        return;
      } else {
        const modalRef = this.modalService.open(CropperComponent, {
          windowClass: "modal-dialog-centered xy-center large-modal",
        });
        modalRef.componentInstance.cropImageContent = {
          modalId: "cropimage",
          titleText: "Edit Image",
          cancelText: "Cancel",
          btnText: "Submit",
          fileEvent: event,
        };
        modalRef.result.then((result) => {
          if (result["success"]) {
            const encodedUrl = result.success.data?.replace(
              /^data:image\/(png|jpg);base64,/,
              ""
            );
            this.base64TrimmedURL = encodedUrl;
            this.dataURItoBlob(this.base64TrimmedURL).subscribe(
              (blob: Blob) => {
                const imageBlob: Blob = blob;
                const imageName: string = this.generateName();
                const f: File = new File([imageBlob], imageName, {
                  type: "image/png",
                });
                formData.append("file", f);
                const headers = new HttpHeaders({
                  "x-access-token": localStorage.getItem("token"),
                });
                this.subCatmediaLoader = true;
                this.http
                  .post(this.apiUrl + "cloudStorage/uploadFile/", formData, {
                    headers: headers,
                  })
                  .subscribe((event) => {
                    let subCatimageUrl = event["data"];
                    this.subcatImgUrl = subCatimageUrl;
                    setTimeout(() => {
                      this.subCatmediaLoader = false;
                    }, 1300);
                  });
              }
            );
          } else {
            this.subCatimageloader = false;
          }
        });
      }
    });
  }
  removesubCatImg() {
    this.subcatImgUrl = "";
  }
  close() {
    this.dialogRef.close({ success: false });
  }
}
